export default __webpack_public_path__ + "static/media/Partners_CommonMenu.8ed2afcc.svg";